import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';
import { WpSectionCode, WpClientCode, WpCityCode } from '../../../services/http/wordpress/wordpress.interface';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-municipy-page',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './municipy-page.component.html',
  styleUrl: './municipy-page.component.scss'
})
export class MunicipyPageComponent {
  code: string | null;

  municipyText = '';
  title = "";
  description = "";
  image = "";

  constructor(
    private readonly wordpressService: WordpressService,
    private readonly activeRoute: ActivatedRoute
  ) {
    this.code = this.activeRoute.snapshot.paramMap.get('code');
    this.wordpressService.getPost({section: WpSectionCode.municipy, client: WpClientCode.genCat, city: Number.parseInt(this.code || '0') as WpCityCode || undefined}).subscribe((response) => {
      this.municipyText = response?.content.rendered || '';
      this.title = response?.title.rendered || '';
      this.image = response?.acf.image_url || '';
    });
  }
}